import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoCausaDiferimiento, TipoCausaDiferimientoProps } from '../../interfaces/catalogos/TipoCausaDiferimientoInterface';

export const TipoCausaDiferimientos = () => {

    return new Promise<TipoCausaDiferimientoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoCausaDiferimiento/', token)
            .then( ({ data } : { data : TipoCausaDiferimientoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoCausaDiferimientos = () => {

    return new Promise<TipoCausaDiferimientoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoCausaDiferimiento/ObtenerTipoCausaDiferimientos', token)
            .then( ({ data } : { data : TipoCausaDiferimientoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoCausaDiferimiento = ( params: TipoCausaDiferimientoProps ) => {

    return new Promise<TipoCausaDiferimientoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoCausaDiferimiento/Actualizar', params, token)
            .then( ({ data } : { data : TipoCausaDiferimientoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoCausaDiferimiento });
            });

        }

    });

}

export const AgregarTipoCausaDiferimiento = ( params: TipoCausaDiferimientoProps ) => {

    return new Promise<TipoCausaDiferimientoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoCausaDiferimiento/Agregar', params, token)
            .then( ({ data } : { data : TipoCausaDiferimientoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoCausaDiferimiento });
            });

        }

    });

}
